import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "required" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-8 fv-row" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_45 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_46 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_47 = { class: "indicator-label" }
const _hoisted_48 = { class: "indicator-progress" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_50 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_51 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_appraiser_create_prices",
  "aria-expanded": "true",
  "aria-controls": "kt_appraiser_create_prices"
}
const _hoisted_52 = { class: "card-title m-0" }
const _hoisted_53 = { class: "fw-bolder m-0" }
const _hoisted_54 = {
  id: "kt_appraiser_create_prices",
  class: "collapse show"
}
const _hoisted_55 = { class: "card-body border-top p-9" }
const _hoisted_56 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_57 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_58 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_59 = { class: "fw-bold" }
const _hoisted_60 = { class: "fs-6 text-gray-600" }
const _hoisted_61 = { class: "row mb-6" }
const _hoisted_62 = { class: "col fv-row" }
const _hoisted_63 = { class: "py-0" }
const _hoisted_64 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_65 = ["href", "aria-controls"]
const _hoisted_66 = { class: "me-3 rotate-90" }
const _hoisted_67 = { class: "svg-icon svg-icon-3" }
const _hoisted_68 = { class: "me-3" }
const _hoisted_69 = { class: "d-flex align-items-center" }
const _hoisted_70 = { class: "text-gray-800 fw-bolder" }
const _hoisted_71 = ["id"]
const _hoisted_72 = { class: "d-flex flex-wrap py-5" }
const _hoisted_73 = { class: "flex-equal me-5" }
const _hoisted_74 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_75 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_76 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_78 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = { class: "indicator-label" }
const _hoisted_81 = { class: "indicator-progress" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'cce'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewCceCategorie')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.cceSubCategorieSchema
            }, {
              default: _withCtx(({ values }) => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('titleAr')), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "titleAr",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('titleAr')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "titleAr" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('titleEn')), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "titleEn",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('titleEn')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "titleEn" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate('cceCategory')), 1),
                      _createElementVNode("i", {
                        class: "fas fa-exclamation-circle ms-1 fs-7",
                        "data-bs-toggle": "tooltip",
                        title: _ctx.translate('cceCategoryTooltip')
                      }, null, 8, _hoisted_20)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "categoryId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedCategory,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCategory) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.translate('selectCceCategory')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cceCategories, (cceCategory) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: cceCategory.id,
                              value: cceCategory.id
                            }, _toDisplayString(cceCategory.title), 9, _hoisted_23))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_ErrorMessage, { name: "categoryId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.translate('multiplier')), 1),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "multiplier",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('multiplier'),
                        "onUpdate:modelValue": ($event: any) => (
                  values.multiplier = Number(values.multiplier)
                )
                      }, null, 8, ["placeholder", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_ErrorMessage, { name: "multiplier" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate('defaultPrice')), 1),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "defaultPrice",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('defaultPrice'),
                        "onUpdate:modelValue": ($event: any) => (
                  values.defaultPrice = Number(values.defaultPrice)
                )
                      }, null, 8, ["placeholder", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_ErrorMessage, { name: "defaultPrice" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('sort')), 1),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "sort",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('sort'),
                        "onUpdate:modelValue": ($event: any) => (values.sort = Number(values.sort))
                      }, null, 8, ["placeholder", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_ErrorMessage, { name: "sort" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_41, [
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      name: "isDependQuality",
                      type: "checkbox",
                      value: "true",
                      checked: "checked"
                    }),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_ErrorMessage, { name: "isDependQuality" })
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.translate('isDependQuality')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  _createElementVNode("button", _hoisted_46, [
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_48, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_49
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'cce'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("h3", _hoisted_53, _toDisplayString(_ctx.translate('subCategoriesOptions')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              (!_ctx.createdSubCategory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("span", _hoisted_57, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.translate('savingSubCategoryOptionsNote')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subOptions, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center collapsible rotate collapsed",
                            href: `#kt_property_type_${index}`,
                            "aria-controls": `kt_property_type_${index}`,
                            "data-bs-toggle": "collapse",
                            role: "button",
                            "aria-expanded": "true"
                          }, [
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("span", _hoisted_67, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _createElementVNode("div", _hoisted_70, _toDisplayString(item.title), 1)
                              ])
                            ])
                          ], 8, _hoisted_65)
                        ]),
                        _createElementVNode("div", {
                          id: `kt_property_type_${index}`,
                          class: "fs-6 ps-10 collapse show",
                          "data-bs-parent": "#kt_property_type",
                          style: {}
                        }, [
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("table", _hoisted_74, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.translate('price')), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        autocomplete: "off",
                                        class: "form-control form-control-sm form-control-solid",
                                        placeholder: _ctx.translate('price'),
                                        "onUpdate:modelValue": ($event: any) => ((item.price) = $event)
                                      }, null, 8, _hoisted_76), [
                                        [_vModelText, item.price]
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ], 8, _hoisted_71)
                      ]),
                      _hoisted_77
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_appraiser_create_prices_submit",
                ref: "submitSubCategoryOptionstButton",
                class: "btn btn-primary",
                disabled: !_ctx.createdSubCategory,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmitSubCategoryOptions && _ctx.onSubmitSubCategoryOptions(...args)))
              }, [
                _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_81, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_82
                ])
              ], 8, _hoisted_79)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}